/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Status_UnavailableInputs */

const cs_sms_status_unavailable = /** @type {(inputs: Sms_Status_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav SMS není dostupný.`)
};

const en_sms_status_unavailable = /** @type {(inputs: Sms_Status_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS status unavailable.`)
};

/**
* | output |
* | --- |
* | "SMS status unavailable." |
*
* @param {Sms_Status_UnavailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_status_unavailable = /** @type {((inputs?: Sms_Status_UnavailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Status_UnavailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_status_unavailable(inputs)
	return cs_sms_status_unavailable(inputs)
});